<template>
  <div id="printQR" class="printableArea">

    <!-- ─── Header ─── -->
    <div class="text-center">
      <img
        v-if="storeLogo"
        :src="storeLogo"
        :alt="storeName"
        width="70"
        class="logo"
      />
      <h4 class="font pt-2 text-capitalize">{{ storeName }}</h4>
    </div>

    <hr class="dot" />

    <!-- ─── Table number ─── -->
    <div class="text-center">
      <div class="font bfr-table-label">{{ $t("table_no") }}</div>
      <div class="font bfr-table-number">{{ tableName }}</div>
    </div>

    <hr class="dot" />

    <!-- ─── Buffet info (buffet stores only) ─── -->
    <template v-if="isBuffet && buffetPlans.length">
      <div class="font default font-weight-bold">{{ $t("buffet_plans") }}</div>
      <div
        v-for="(plan, i) in buffetPlans"
        :key="i"
        class="printClass font default"
      >
        <div>{{ plan.persons }}x {{ buffetPlanName(plan) }} ({{ formatNumber(plan.unit_price) }})</div>
        <div>{{ formatNumber(plan.subtotal) }}</div>
      </div>

      <div class="printClass font default" style="margin-top:4px">
        <div>{{ $t("start_time") }}</div>
        <div>{{ startTime }}</div>
      </div>
      <div class="printClass font default">
        <div>{{ $t("end_time") }}</div>
        <div>{{ endTime }}</div>
      </div>

      <hr class="dot" />
    </template>

    <!-- ─── QR code ─── -->
    <div class="text-center" style="margin: 6px 0 2px">
      <div class="font default" style="font-size: 10px; margin-bottom: 4px">
        {{ $t("scan_to_order") }}
      </div>
      <img :src="highQualityQr" alt="QR Code" class="bfr-qr-img" style="width:200px;height:200px" />
    </div>

    <hr class="dot" />

    <!-- ─── Footer ─── -->
    <div class="font text-center" style="font-size: 10px">
      {{ $t("table_qr_code") }}
    </div>

  </div>
</template>

<script>
export default {
  name: "QrPrint",
  props: {
    qr: { type: String, required: true },
    tableName: { type: String, default: "" },
    storeName: { type: String, default: "" },
    storeLogo: { type: String, default: null },
    isBuffet: { type: Boolean, default: false },
    buffetPlans: { type: Array, default: () => [] },
    startTime: { type: String, default: "--:--" },
    endTime: { type: String, default: "--:--" },
  },
  computed: {
    highQualityQr() {
      return this.qr.replace(/size=\d+x\d+/, "size=400x400");
    },
  },
  methods: {
    buffetPlanName(plan) {
      return plan.plan_name || plan.buffet_plan_name || plan.name || "";
    },
    formatNumber(n) {
      if (n == null) return "";
      return Number(n).toLocaleString();
    },
  },
};
</script>
